export type OrderOptimizerRailyDetailsItemStepsOrdersPoints = {
  displayName: string;
  time: Date;
  haltingTime: number;
  distance: number;
  driverTime: Date | null;
  driverHaltingTime: number;
  driverDrivingTime: number;
  driverDistance: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerRailyDetailsItemStepsEndToHome = {
  displayName: string;
  driverTime: Date;
  driverDrivingTime: number;
  driverDistance: number;
};

export type OrderOptimizerRailyDetailsItemStepsOrders = {
  points: OrderOptimizerRailyDetailsItemStepsOrdersPoints[];
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerRailyDetailsItemStepsHomeToStart = {
  displayName: string;
  driverTime: Date;
};

export type OrderOptimizerRailyDetailsItemSteps = {
  homeToStart: OrderOptimizerRailyDetailsItemStepsHomeToStart | null;
  orders: OrderOptimizerRailyDetailsItemStepsOrders[];
  endToHome: OrderOptimizerRailyDetailsItemStepsEndToHome | null;
};

export type OrderOptimizerRailyDetailsItemOrdersByDriverSabs = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerRailyDetailsItemOrdersByDriverAba = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerRailyDetailsItemDriver = {
  driverId: string;
  displayName: string;
  taxiCorporation: string;
  startLat: number;
  startLon: number;
  contractRate: number;
};

export type OrderOptimizerRailyDetailsItemOptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerRailyDetailsItemUnoptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerRailyDetailsItemOrders = {
  humanId: number;
  cargoCompany: string;
  billingModel: string;
  taxiCorporation: string;
  totalTime: number;
  haltingTime: number;
  distance: number;
  startTime: Date;
  planEntryHumanId: number | null;
  driverName: string | null;
  fleetPartner: string | null;
};

export enum OrderOptimizerRailyDetailsItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

type OrderOptimizerRailyDetailsItem = {
  reviewedBy: string | null;
  reviewedAt: Date | null;
  orders: OrderOptimizerRailyDetailsItemOrders[];
  unoptimizedStats: OrderOptimizerRailyDetailsItemUnoptimizedStats;
  optimizedStats: OrderOptimizerRailyDetailsItemOptimizedStats;
  driver: OrderOptimizerRailyDetailsItemDriver | null;
  ordersByDriverAba: OrderOptimizerRailyDetailsItemOrdersByDriverAba | null;
  ordersByDriverSabs: OrderOptimizerRailyDetailsItemOrdersByDriverSabs | null;
  saAndBsDistance: number;
  steps: OrderOptimizerRailyDetailsItemSteps;
  score: number;
  status: OrderOptimizerRailyDetailsItemStatus;
  totalCargoIncome: number;
  totalDriverHaltingCost: number;
};

export default OrderOptimizerRailyDetailsItem;
